export const emailRegex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
